import './ConnectionPill.css';

export type ConnectionStatus = 'connecting' | 'connected' | 'reconnecting' | 'offline';

interface Props {
  status: ConnectionStatus;
}

const labels: Record<ConnectionStatus, string> = {
  connecting: 'Connecting',
  connected: 'Live',
  reconnecting: 'Reconnecting',
  offline: 'Offline',
};

export function ConnectionPill({ status }: Props) {
  return (
    <div className={`connection-pill connection-pill-${status}`}>
      <span className="connection-dot" />
      <span className="connection-label">{labels[status]}</span>
    </div>
  );
}
